import { enumStringKeys } from '@sonar-software/sonar-ts-lib';
import { FilterComponent } from './FilterComponent';
import { getDirectParent } from '@lib/popups';
import { getFilterId } from '../@arch/lib';
import React from 'react';

import { COPY_SPECIFIC, PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import { FieldPermission, ObjectPermission } from '@sonar-software/sonar-core';
import { FilterOption, OptionFilter } from '@periscopes/general/filters';

const objectPermissionLabel: Record<ObjectPermission, string> = {
	[ ObjectPermission.create ]: COPY_SPECIFIC.CREATE,
	[ ObjectPermission.read ]: COPY_SPECIFIC.READ,
	[ ObjectPermission.edit ]: COPY_SPECIFIC.EDIT,
	[ ObjectPermission.delete ]: COPY_SPECIFIC.DELETE,
	[ ObjectPermission.viewAllData ]: COPY_SPECIFIC.VIEW_ALL_DATA,
	[ ObjectPermission.modifyAllData ]: COPY_SPECIFIC.MODIFY_ALL_DATA
};

const fieldPermissionLabel: Record<FieldPermission, string> = {
	[ FieldPermission.read ]: COPY_SPECIFIC.READ,
	[ FieldPermission.edit ]: COPY_SPECIFIC.EDIT
};

const getOptions = (isFieldAccess: boolean): Array<FilterOption> => {
	if (isFieldAccess) {
		return enumStringKeys(FieldPermission).map((entry) => ({
			label: fieldPermissionLabel[ entry ],
			value: FieldPermission[ entry ]
		}));
	}

	return enumStringKeys(ObjectPermission).map((entry) => ({
		label: objectPermissionLabel[ entry ],
		value: ObjectPermission[ entry ]
	}));
};

export const AccessLevelFilter: FilterComponent<Array<ObjectPermission | FieldPermission> | undefined> = (props) => {
	const { format, id, label, onChange, value } = props;

	const isFieldAccess = label === COPY_SPECIFIC.FIELD_ACCESS;
	const options = getOptions(isFieldAccess);

	const getPermissionLabel = (permission: ObjectPermission | FieldPermission): string => {
		if (isFieldAccess) {
			return fieldPermissionLabel[ permission as FieldPermission ];
		}

		return objectPermissionLabel[ permission as ObjectPermission ];
	};

	return (
		<FilterComponent
			{ ...props }
			tagProps={ {
				clearValue: undefined,
				label: isFieldAccess ? COPY_SPECIFIC.FIELD_ACCESS : COPY_SPECIFIC.OBJECT_ACCESS,
				value: value
					?.map((entry) => getPermissionLabel(entry))
					.join(', ')
			} }>
			<OptionFilter
				className='filter'
				getPopupContainer={ getDirectParent }
				id={ getFilterId(String(id)) }
				maxTagCount='responsive'
				mode='multiple'
				onChange={ (selection: Array<ObjectPermission | FieldPermission>) => {
					onChange({
						[ id ]: {
							format,
							value: selection
						}
					});
				} }
				options={ options }
				placeholder={ PLACEHOLDERS_COPY.FILTER_BY(COPY_SPECIFIC.ACCESS_LEVEL) }
				showArrow
				value={ value } />
		</FilterComponent>
	);
};
